import { Flex, Flexed, PhoneNumber } from '../../utilities/Shared';
import { useMemo } from 'react';
import { MdDelete } from 'react-icons/md';
import { LuEdit } from 'react-icons/lu';
import { useNavigate } from 'react-router-dom';
import { sortit, sortnum, sortsalesreps, sortcsrreps } from '../../utilities/Sort';

const CustomerPanel = ({ vendorlist, search, setVendorinfo, setEditVendor, setDeletevendor, order, rowclass, setList, setOrder,stat }) => {
  const nav = useNavigate();

  // Memoize the filtered list
  const filteredList = useMemo(() => {
    console.log('vendorlist in CustomerPanel:', vendorlist);
    return vendorlist?.filter((item) => {
      if (search.toLowerCase() === '') return true;
      return (
        (item.name ?? '').toLowerCase().includes(search.toLowerCase()) ||
        (item.company_id ?? '').toString().includes(search) ||
        (item.dba ?? '').toLowerCase().includes(search) || 
        (item.salesrep.firstName ?? '').toLowerCase().includes(search.toLowerCase())
      );
    }) || [];
  }, [vendorlist, search]);

  console.log('filteredList:', filteredList);

  return (
    <>
      <Flexed
        style={{ borderBottom: '1px solid black', padding: '4px', background: '#8398AB', color: 'white', marginBottom: '5px' }}
        className="hand"
      >
        <Flex flex=".8" onClick={() => sortnum('company_id', order, vendorlist, setList, setOrder)}>
          Id
        </Flex>
        <Flex flex="2" onClick={() => sortit('name', order, vendorlist, setList, setOrder)}>
          Customer
        </Flex>
        <Flex flex="1.4">Contact</Flex>
        <Flex>Email</Flex>
        <Flex flex="">Phone</Flex>
        <Flex flex="" onClick={() => sortsalesreps('salesrep', order, vendorlist, setList, setOrder)}>
          Sales Rep
        </Flex>
        <Flex flex="" onClick={() => sortcsrreps('custrep', order, vendorlist, setList, setOrder)}>
          CSR Rep
        </Flex>
     
      </Flexed>

      {filteredList.map((customer, index) => (
        <Flexed className={rowclass} key={index} margin="0" borderBottom="1px solid lightgrey">
          <Flex className="" flex=".8" onClick={() => nav(`customer/${customer._id}`)}>
            {customer.company_id || 'N/A'}
          </Flex>
          <Flex className="" flex="2" onClick={() => nav(`customer/${customer._id}`)}>
            {customer.name || 'N/A'}
          </Flex>
          <Flex className="" flex="1.4" onClick={() => nav(`customer/${customer._id}`)}>
            {customer.contacts?.find((it) => it.contactid === customer.maincontact)?.name || 'N/A'}
          </Flex>
          <Flex className="" onClick={() => nav(`customer/${customer._id}`)}>
            {customer.contacts?.find((it) => it.contactid === customer.maincontact)?.email || 'N/A'}
          </Flex>
          <Flex className="" onClick={() => nav(`customer/${customer._id}`)} flex="">
            {PhoneNumber(customer.mainphone || '')}
          </Flex>
          <Flex className="" onClick={() => nav(`customer/${customer._id}`)} flex="">
            {customer.salesrep ? `${customer.salesrep.firstName || ''} ${customer.salesrep.lastName || ''}` : 'N/A'}
          </Flex>
          <Flex className="" onClick={() => nav(`customer/${customer._id}`)} flex="">
            {customer.custrep ? `${customer.custrep.firstName || ''} ${customer.custrep.lastName || ''}` : 'N/A'}
          </Flex>
         
        </Flexed>
      ))}
    </>
  );
};

export default CustomerPanel;